import ColorPicker from 'simple-color-picker';

import Base from 'app/views/base';

import RemovePropertyButtonView, { REMOVE_TYPES } from 'app/components/pages/brand/remove_property';

import tmpl from './template';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'focus input': 'showColorPicker',
    'click .input-group-addon': 'focusInput',
    'blur input': 'hideColorPicker',
    'keyup input': 'setColorPreview',
  },

  initialize({
    modelProperty, label = 'Color', removeText = 'Reset', placeholder = '#0000FF',
  }) {
    this.modelProperty = modelProperty;
    this.label = label;
    this.removeText = removeText;
    this.placeholder = placeholder;
    if (this.removeText) {
      this.addSubview('resetColor', '.reset-color', new RemovePropertyButtonView({
        model: this.model,
        property: this.modelProperty,
        type: REMOVE_TYPES.LINK,
        text: this.removeText,
      }));
    }
  },

  afterRender() {
    this.setColorPreview();
  },

  context() {
    return {
      color: this.model.escape(this.modelProperty),
      label: this.label,
      placeholder: this.placeholder,
    };
  },

  showColorPicker(e) {
    const inputField = this.$(e.target);
    const el = inputField.parent().siblings('.scp-container').get(0);
    const colorPicker = new ColorPicker({
      el,
      color: inputField.val(),
      background: '#FFFFFF',
      height: '200',
      width: '250',
    });
    colorPicker.onChange(color => {
      this.model.set(this.modelProperty, color.toUpperCase());
      inputField.val(color.toUpperCase());
      this.setColorPreview();
    });
  },

  focusInput() {
    this.$('input').focus();
  },

  setColorPreview(e) {
    if (e) this.model.set(this.modelProperty, this.$(e.target).val());
    this.$('.color-preview').css('background-color', this.model.escape(this.modelProperty));
  },

  hideColorPicker() {
    this.$('.Scp').remove();
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/brand/color_picker/index.js